module.exports = __webpack_public_path__ + "img/42751593507940_.pic_hd.755d879d.png";